import type { IContact, ICustomerBase } from '../api/domain';
import { Permission } from '../enum/permission';

const hasPermission = (customerBase: ICustomerBase, permission: Permission) => customerBase.permissions.includes(permission);
export const hasPopupsPermission = (customerBase: ICustomerBase) => customerBase && customerBase.permissions.includes(Permission.POPUPS);
export const hasProductsPermission = (customerBase?: ICustomerBase) => customerBase === undefined || hasPermission(customerBase, Permission.PRODUCTS);
export const hasUploadDocumentPermission = (customerBase?: ICustomerBase) =>
    customerBase === undefined || hasPermission(customerBase, Permission.UPLOAD_DOCUMENT);
export const hasSendMessagePermission = (customerBase?: ICustomerBase) => customerBase === undefined || hasPermission(customerBase, Permission.SEND_MESSAGE);
export const hasOnSiteBranchPermission = (customerBase?: ICustomerBase, contact?: IContact) => {
    if (!contact) {
        return false;
    }

    if (customerBase?.type === 'PRIVATE' && contact.appointmentAtHomeForPrivate) {
        return true;
    }

    return customerBase?.type === 'COMPANY' && contact.appointmentAtHomeForCompany;
};
export const hasPowerOfAttorneyPermission = (customerBase?: ICustomerBase) =>
    customerBase === undefined || hasPermission(customerBase, Permission.POWER_OF_ATTORNEY);
export const hasEBankingContractsPermission = (customerBase?: ICustomerBase) =>
    customerBase === undefined || hasPermission(customerBase, Permission.EBANKING_CONTRACTS);
export const hasOrderClientRelationPermission = (customerBase?: ICustomerBase) =>
    customerBase === undefined || hasPermission(customerBase, Permission.ORDER_CLIENT_RELATION);
export const hasOrdersPermission = (customerBase?: ICustomerBase) => customerBase === undefined || hasPermission(customerBase, Permission.ORDERS);
export const hasPersonalDataPermission = (customerBase?: ICustomerBase) => customerBase === undefined || hasPermission(customerBase, Permission.PERSONAL_DATA);
export const hasAddressesPermission = (customerBase?: ICustomerBase) => customerBase === undefined || hasPermission(customerBase, Permission.ADDRESSES);
export const hasContactInfoPermission = (customerBase?: ICustomerBase) => customerBase === undefined || hasPermission(customerBase, Permission.CONTACT_INFO);
export const hasMasterDataPermission = (customerBase?: ICustomerBase) =>
    customerBase === undefined || hasPersonalDataPermission(customerBase) || hasAddressesPermission(customerBase) || hasContactInfoPermission(customerBase);
